<template>
  <Layout>
    <Card>
      <p slot="title">系统角色管理</p>
      <Button
        class="titleBtn"
        type="primary"
        icon="el-icon-plus"
        @click="addClick"
      >新增角色</Button
      >
      <div class="content">
        <el-table :data="tableData" style="  width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="roleId"
            label="roleId"
            minWidth="140"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="roleName"
            label="roleName"
            minWidth="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="menuIdList"
            label="menuIdList"
            minWidth="80"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createUserId"
            label="createUserId"
            minWidth="180"
            align="center"
          ></el-table-column>
          <el-table-column align="center" minWidth="200" label="操作">
            <template slot-scope="scope">
              <span @click="refundClick(scope.row)">修改</span>
              <!--<span @click="deletes(scope.row)">删除</span>-->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pagenum"
          @current-change="handleCurrentChange"
          :total="total"
        />
      </div>
    </Card>

    <el-dialog title="系统角色信息" :visible.sync="revamp" minWidth="480px">
      <el-form :model="form" class="formCss">
        <el-form-item label="roleName" :label-width="formLabelWidth">
          <el-input v-model="form.roleName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="remark" :label-width="formLabelWidth">
          <el-input v-model="form.remark" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <Button @click="revamp = false">取 消</Button>
        <Button type="primary" @click="newlyyys(form)">确 定</Button>
      </div>
    </el-dialog>
  </Layout>
</template>

<script>
import { api } from "@/request/api";

export default {
  data() {
    return {
      total: 10,
      pagenum: 1,
      pagesize: 10,

      disabled: false,
      revamp: false,
      form: {
        roleName: "",
        remark: "",
      },
      formLabelWidth: "100px",
      tableData: [],
    };
  },
  created() {
  },
  mounted() {
    // 初始化用户列表
    this.sysRoleInquire();
  },
  methods: {
    deletes(item) {
      //删除
      var that = this;
      this.$confirm("您确定要删除当前方案么?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          var parameter = {
            id: item.id,
          };
          api.yysdelete(parameter).then((response) => {
            if (response.data.code === 0) {
              that.$message({
                type: "success",
                message: "删除成功!",
              });
              that.yysInquire();
            } else {
              that.$message({
                type: "success",
                message: response.data.msg,
              });
            }
          });
        })
        .catch(() => {});
    },
    sysRoleInquire() {
      console.log('sysUser');
      //列表
      let that = this;
      let parameter = {
        page: that.pagenum,
        pagesize: that.pagesize,
      };
      api.sysRoleList(parameter).then((response) => {

        response = response.data;
        console.log(response);
        if (response.code === 0) {
          that.total = response.page.totalCount;
          that.tableData = response.page.list;
        }
      });
    },

    handleCurrentChange(cpage) {
      //分页切换
      this.pagenum = cpage;
      this.sysRoleInquire();
    },
    //新增营养素
    newlyyys(item) {
      let that = this;
      api.sysRoleAdd(item).then((response) => {
        if (response.data.code === 0) {
          that.sysRoleInquire();
          that.revamp = false;
        }
      });
    },
    //修改
    refundClick(item) {
      //修改
      this.revamp = true;
      var that = this;
      var parameter = {
        id: item.id,
      };
      api.yysdetail(parameter).then((response) => {
        if (response.data.code === 0) {
          that.form = response.data.nutrient;
          that.form.imgs = [ { url: response.data.nutrient.img }];
          if (response.data.nutrient.img) {
            that.uploadDisabled = true;
          }
          that.form.humanClassifyId = that.form.humanClassifyId.split(",");
          for (let i = 0; i < that.form.humanClassifyId.length; i++) {
            that.form.humanClassifyId[i] = Number(that.form.humanClassifyId[i]);
          }
        }
      });
    },
    addClick() {
      //新增
      this.revamp = true;
      this.uploadDisabled = false;
      this.form = {
        name: "",
        description: "",
        humanClassifyId: [],
        url: "",
        imgs: [],
      };
    },
  },
};
</script>
<style lang="less">
.formCss .el-checkbox-button {
  height: 22px;
  line-height: 22px;
  margin-left: 10px;
}
.formCss .el-form-item__label {
  line-height: 24px;
}
.formCss .el-radio-button__inner,
.formCss .el-radio-button:first-child .el-radio-button__inner,
.formCss .el-checkbox-button__inner,
.formCss .el-checkbox-button:first-child .el-checkbox-button__inner {
  border-radius: 2px !important;
  border: 1px solid #91d5ff;
  padding: 5px;
  font-size: 12px;
}
.formCss .el-upload--picture-card {
  width: 67px;
  height: 67px;
  line-height: 72px;
  background: rgba(6, 107, 168, 0.04);
  border-radius: 6px;
  border: 2px solid rgba(6, 107, 168, 0.2);
}
.formCss .hide .el-upload--picture-card {
  display: none;
}
.formCss .el-upload-list--picture-card {
  margin-left: 100px;
}
</style>
